import { render } from "./PhoneInput.vue?vue&type=template&id=4cfb036a&scoped=true&ts=true"
import script from "./PhoneInput.vue?vue&type=script&lang=ts"
export * from "./PhoneInput.vue?vue&type=script&lang=ts"

import "./PhoneInput.vue?vue&type=style&index=0&id=4cfb036a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfb036a"]])

export default __exports__